import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './views/not-found/not-found.component';

const routes: Routes = [
    {
        path: '',
        loadChildren: () =>
            import('../app/core/auth/auth.module').then((m) => m.AuthModule),
    },
    {
        path: 'app',
        loadChildren: () =>
            import('./features/app-shell/app-shell.module').then(
                (m) => m.AppShellModule
            ),
    },
    { path: '**', component: NotFoundComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { enableTracing: false })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
